module.exports = __webpack_public_path__ + "img/pic3.9047fee.png";